import axios from "axios";

const fetchRoles = async () => {
  return axios.get("/roles").then(res => res.data);
};

export default { 
  fetchRoles 
};
